import axios from 'axios'
import store from '../store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

http.interceptors.request.use((request) => {
  if (store.state.user.loggedIn) {
    request.headers.authorization = `Bearer ${store.state.user.data.token}`
  }
  return request
})

http.interceptors.response.use(response => response, (err) => {
  if (err.response.status === 401) {
    store.commit('logout')
    window.location.replace('/')
  }

  return Promise.reject(err)
})

export default http
